<vex-page-layout mode="card">
    <vex-page-layout-header class="pb-16 flex flex-col items-start justify-center">
        <div [class.px-gutter]="true" class="w-full flex flex-col sm:flex-row justify-between">
            <div>
                <h1 class="title mt-0 mb-1">Grupos</h1>
                <vex-breadcrumbs [crumbs]="crumbs"></vex-breadcrumbs>
            </div>
        </div>
    </vex-page-layout-header>

    <vex-page-layout-content>
        <div class="card">
            <mat-tab-group>
                <mat-tab label="{{formLabel}}">
                    <div class="p-6">
                        <div class="grid grid-flow-col gap-3">
                            <div class="px-6 py-4 flex flex-col">
                                <form (ngSubmit)="save()" [formGroup]="form" novalidate>
                                    <div class="px-6 py-4 flex flex-col">
                                        <div class="flex flex-col sm:flex-row sm:gap-4">
                                            <mat-form-field class="flex-auto">
                                                <mat-label>Nombre del grupo</mat-label>
                                                <input matInput formControlName="nombre">
                                            </mat-form-field>
                                        </div>
                                        <div style="padding-bottom: 5px" class="flex flex-col sm:flex-row sm:gap-4">
                                            <mat-slide-toggle color="primary" labelPosition="before"
                                                formControlName="activo" [disabled]="true">Estado grupo
                                            </mat-slide-toggle>
                                        </div>
                                        <div style="padding-top: 5px; padding-bottom: 10px" class="flex flex-col sm:flex-row sm:gap-4">
                                            <mat-slide-toggle color="primary" labelPosition="before"
                                                formControlName="alerta" [disabled]="true">Alerta gris
                                            </mat-slide-toggle>
                                        </div>

                                        <hr style="padding-top: 10px">
                                        <p class="text-muted">Opciones de notificación para el grupo</p>
                                        <div style="padding-top: 5px" class="flex flex-col sm:flex-row sm:gap-4">
                                            <mat-slide-toggle color="primary" labelPosition="before"
                                                formControlName="whatsapp" [disabled]="true">WHATSAPP
                                            </mat-slide-toggle>
                                        </div>
                                        <div style="padding-top: 5px" class="flex flex-col sm:flex-row sm:gap-4">
                                            <mat-slide-toggle color="primary" labelPosition="before"
                                                formControlName="sms" [disabled]="true">SMS
                                            </mat-slide-toggle>
                                        </div>
                                        <div style="padding-top: 5px" class="flex flex-col sm:flex-row sm:gap-4">
                                            <mat-slide-toggle color="primary" labelPosition="before"
                                                formControlName="push" [disabled]="true">PUSH NOTIFICATION
                                            </mat-slide-toggle>
                                        </div>
                                        <div style="padding-top: 5px" class="flex flex-col sm:flex-row sm:gap-4">
                                            <mat-slide-toggle color="primary" labelPosition="before"
                                                formControlName="email" [disabled]="true">EMAIL
                                            </mat-slide-toggle>
                                        </div>

                                        <div class="flex items-center justify-end gap-2">
                                            <!-- <button mat-button type="button">{{appSettings.DIALOG_BUTTON_CANCEL}}</button> -->
                                            <button color="primary" mat-raised-button type="submit"
                                                [disabled]="form.invalid">{{actionType ==='update'?
                                                appSettings.DIALOG_BUTTON_UPDATE_POSITIVE:
                                                appSettings.DIALOG_BUTTON_PERSIST_POSITIVE}}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Socios" *ngIf="actionType === 'update'">
                    <div class="p-6 mt-20">
                        <div class="card overflow-auto -mt-16">
                            <div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">
                                <div
                                    class="bg-foreground rounded-full border px-4 max-w-[300px] flex-auto flex items-center border border-gray-300">
                                    <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
                                    <input [(ngModel)]="searchKey" (keyup)="applyFilter($event)" autocomplete="off"
                                        class="px-4 py-2 border-0 outline-none w-full bg-transparent"
                                        placeholder="Buscar..." type="search">
                                </div>
                                <span class="flex-1"></span>
                                <button mat-icon-button type="button" matTooltip="Exportar a Excel"
                                    (click)="exporter.exportTable('xlsx', {fileName: 'socios_grupo'})">
                                    <mat-icon class="text-secondary" svgIcon="mat:file_copy"></mat-icon>
                                </button>
                                <button (click)="agreeGrupoSocio()" class="ml-4 flex-none" color="primary" mat-mini-fab
                                    matTooltip="Agregar socio a grupo" type="button">
                                    <mat-icon svgIcon="mat:add"></mat-icon>
                                </button>
                            </div>
                            <table [dataSource]="dataSource" class="w-full" mat-table matSort matTableExporter
                                #exporter="matTableExporter">
                                <ng-container matColumnDef="razonSocial">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Razón social</th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{element.razonSocial}}</td>
                                </ng-container>
                                <ng-container matColumnDef="contacto">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Contacto</th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{element.contacto}}</td>
                                </ng-container>
                                <ng-container matColumnDef="email">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Email</th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{element.email}}</td>
                                </ng-container>
                                <ng-container matColumnDef="celular">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Celular</th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{element.celular}}</td>
                                </ng-container>
                                <ng-container matColumnDef="fechaRegistro">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Fecha registro</th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{element.fechaRegistro}}</td>
                                </ng-container>
                                <ng-container matColumnDef="usuarioRegistro">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header>Usuario</th>
                                    <td *matCellDef="let element" class="text-secondary" mat-cell>{{element.usuarioRegistro}}</td>
                                </ng-container>
                                <ng-container matColumnDef="actions">
                                    <th *matHeaderCellDef mat-header-cell mat-sort-header></th>
                                    <td *matCellDef="let element" class="w-10 text-secondary" mat-cell>
                                        <button (click)="deleteGrupoSocio(element)" mat-icon-button type="button">
                                            <mat-icon svgIcon="mat:delete"></mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                            <mat-paginator [pageSizeOptions]="appSettings.PAGE_SIZE_OPTIONS"
                                [pageSize]="appSettings.PAGE_SIZE" class="sticky left-0"></mat-paginator>

                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </vex-page-layout-content>
</vex-page-layout>